// eslint-disable-next-line
import StateManager from '../user/stateManager';

export const PRO_FIRST_CLIENT_ADDED_KEY = 'proFirstClientAdded';
export const CELL_PHONE_TYPE = 0;

/**
 * Retrieves the cell phone of the client
 * @param {array} phones - list of phones the client may have
 */
export const getCellPhone = phones => {
  const cellPhones = phones.filter(phone => phone.type === CELL_PHONE_TYPE);

  if (cellPhones.length > 0) {
    // Only one cell phone is possible
    return cellPhones[0];
  }

  return null;
};

/**
 * Gets the phone type
 * @param {object} phone - the phone object
 */
export const getPhoneType = phone => (phone.type === CELL_PHONE_TYPE ? 'Cell' : 'Home');

/**
 * Updates s3 to indicate if very first client added (fly-2218)
 * @param {array} clients - a list of clients
 */
export const addFirstClient = async clients => {
  const firstClientAdded = await StateManager.getActionValue(PRO_FIRST_CLIENT_ADDED_KEY);
  if (!firstClientAdded && clients.length) {
    StateManager.addAction(PRO_FIRST_CLIENT_ADDED_KEY, true);
  }
};

/**
 * Checks s3 to see if any clients have been added yet, if not, then will be first client added
 */
export const isFirstClientAdded = async () => {
  const firstClientAlreadyAdded = await StateManager.getActionValue(PRO_FIRST_CLIENT_ADDED_KEY);
  if (firstClientAlreadyAdded) {
    return false;
  }
  return true;
};
